import { SurveyPreviewPropsTypes } from "../SurveyPreviewPropsTypes";
import SupplierView from "../../SupplierView";
function SurveyPreview({
  surveyAnswersInfo,
  surveyAnswers,
  questionObjVariable,
  isSurveyLoaded,
}: SurveyPreviewPropsTypes) {
  return (
    <SupplierView
      surveyAnswersInfo={surveyAnswersInfo}
      surveyAnswers={surveyAnswers}
      questionObjVariable={questionObjVariable}
      isSurveyLoaded={isSurveyLoaded}
      isPreview={true}
    />
  );
}
export default SurveyPreview;
